import { ESavedSearchNotificationActionTypes } from '../../actions/savedSearchesNotification/types';
import { TReduxActions } from '../../types/redux';
import { ISavedSearchesNotificationState } from '../../types/savedSearch';

export const initialState = {
  visible: false,
};

export function savedSearchesNotificationReducer(
  state: ISavedSearchesNotificationState = initialState,
  action: TReduxActions,
) {
  switch (action.type) {
    case ESavedSearchNotificationActionTypes.Visible:
      return {
        ...state,
        savedSearchesNotification: {
          visible: action.payload.visible,
        },
      };
    default:
      return state;
  }
}
